export const cooperationRequestTypes = {
    fromPatientToTherapist: 0,
    fromTherapistToPatient: 1,
};
